import axios from "axios";
import qs from "qs";
import ToastPlugin from "vux/src/plugins/toast";
import Vue from "vue";
import Cookies from "js-cookie";
Vue.use(ToastPlugin);

let baseURL = "/api";
// axios.defaults.baseURL = '/api';
// axios.defaults.baseURL = '/api_lj';
axios.defaults.baseURL = baseURL;
axios.defaults.timeout = 30 * 1000;
//axios.defaults.baseURL = 'http://101.200.125.192:62/api';

export const requestUrl = baseURL;

axios.interceptors.request.use(
  config => {
    config.data = {
      token: Cookies.get("token") ? Cookies.get("token") : "",
      code: Cookies.get("code") ? Cookies.get("code") : "",
      openId: Cookies.get("openId") ? Cookies.get("openId") : "",
      ...config.data
    };
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.code != 0) {
      if (res.message == "please.binding.users") {
        // Vue.$vux.toast.text('请先绑定读者证');
      } else if (res.message == "not.found.lib") {
        Vue.$vux.toast.text("无法获取馆信息");
      } else if (res.message == "please.login") {
        if (!Cookies.get("openId")) {
          Vue.$vux.toast.text("请先登录");
        }
        // Cookies.remove('openId');
        // Cookies.remove('username');
        // Cookies.remove('dzzhao');
      } else {
        Vue.$vux.toast.text(res.message);
      }
      return Promise.reject(res.message);
    }
    return res;
  },
  error => {
    if (
      error.code === "ECONNABORTED" &&
      error.message.indexOf("timeout") != -1
    ) {
      Vue.$vux.toast.text("服务器超时，请稍后重试");
    } else {
      // Vue.$vux.toast.text('error');
    }
    return Promise.reject(error);
  }
);

/**
 * 封装axios的通用请求
 * @param  {string}   method     get\post\put\delete
 * @param  {string}   url       请求的接口URL
 * @param  {object}   param     传的参数，没有则传空对象
 */
function http(method, url, param) {
  param = param && typeof param === "object" ? param : {};
  const config = {
    url: url,
    method: method,
    transformRequest: [
      function(param) {
        return qs.stringify(param);
      }
    ],
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  };

  // post请求时需要设定Content-Type
  if (method === "post") {
    config.headers["Content-Type"] =
      "application/x-www-form-urlencoded; charset=UTF-8";
    config.data = param;
  } else if (method === "get") {
    config.params = param;
  }
  return axios(config);
}

export default {
  http
};
